import Container from '@/components/Container';

const PodcastSkeleton = () => {
  return (
    <div className={`animate-pulse`}>
      <Container className={`mt-20`}>
        <div className="col-span-12 flex justify-center gap-4">
          <div className="h-full w-1/5 animate-pulse  bg-gray-300 py-4"></div>
        </div>

        <div className="col-span-12 flex gap-4">
          <div className="h-full w-full animate-pulse  bg-gray-300 py-1"></div>
        </div>
        <div className="col-span-12 flex gap-4">
          <div className="h-full w-full animate-pulse  bg-gray-300 py-4"></div>
          <div className="h-full w-full animate-pulse  bg-gray-300 py-4"></div>
          <div className="h-full w-full animate-pulse  bg-gray-300 py-4"></div>
          <div className="h-full w-full animate-pulse  bg-gray-300 py-4"></div>
        </div>

        <div className="col-span-12 flex h-[400px]">
          <div className="h-full w-full animate-pulse  bg-gray-300 py-8"></div>
        </div>
      </Container>
    </div>
  );
};

export default PodcastSkeleton;
